<template>
    <section id="builder" class="ppt-section-main">

        <loading 
            :active.sync="loader.state" 
            :is-full-page="true">    
        </loading>

        <div class="ppt-container-graph" v-bind:class="{ hidden: show_neovis }">
              
            <div id="popoto-taxonomy" class="ppt-taxo-nav"></div>
            <div v-bind:style="{ height: graph_height + '%' }" id="popoto-graph" class="ppt-div-graph"></div>
            <div id="popoto-results" class="table-holder"></div>
            <div id="popoto-cypher" class="ppt-container-cypher" ref="cypher"></div>

            <div class="action-sets">

                <div id="popoto-cypher"></div>

                <va-button
                    class="toggle-filters"
                    :disabled="show_table"
                    :color="( !show_filter ) ? 'dark' : 'success'"
                    large
                    @click="killPopoto()"
                >
                Reset prefilter(s)
                </va-button>
                <va-button
                    :disabled="total < 1 || show_filter"
                    class="toggle-results"
                    large
                    :color="( !show_table ) ? 'info' : 'success'"
                    :icon="( !show_table ) ? 'iconicstroke iconicstroke-list' : 'iconicstroke iconicstroke-x'"
                    @click="show_table = (show_table) ? false : true"
                >
                {{ ( show_table )  ? "Close" : "Results"}} ({{ total }})
                </va-button>
                <va-button
                    :disabled="total < 1"
                    class="run-query"
                    large
                    @click="runQuery()"
                >
                Run Query
                </va-button>
            </div>

        </div>
        <div class="neovis-graph" v-bind:class="{ hidden: !show_neovis }">
                <div id="viz"></div>
                <div class="neovis-action-sets">
                    <va-button
                        :disabled="total < 1"
                        class="run-query"
                        large
                        @click="backToSearch()"
                    >
                    Back
                    </va-button>
                    <va-button
                            :disabled="total < 1"
                            class="stabilize"
                            large
                            @click="stopPhysics()"
                        >
                        Stabilize
                    </va-button>
                </div>

        </div>
    </section>
</template>
<script>

    import * as popoto from "../../../node_modules/popoto";
    import * as encode from "nodejs-base64-encode";
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import Event from '@/app/events';
    import * as neovis from "../../../node_modules/neovis.js/dist/neovis.js"

    export default {

        props:{
            filters: {
              type: Array,
              required: true
            }
        },

        components: { Loading },

        /**
         * Data:
         * accesable object to Vue’s base reactivity system
         * @var <Observable>
         */
        data () {
            return {

                show_neovis: false,
                show_table: false,
                show_filter: false,
                cypher_string: "",
                total: 0,
                popotpo: null,
                pre_filters: [
                ],
                loader:{
                    state: false,
                    message: 'Loding...'
                },

                builder: null,

                time_stamps: [
                    "scraped_at",
                    "created_at"
                ],

                /**
                 * Providers:
                 * Neo4j accesable entities and 
                 * key binding
                 * @var <Object>
                 */
                providers:{

                    "Hashtag": {
                        "returnAttributes": [
                            "hashtag",
                            "scraped_at"
                        ],
                        //"getPredefinedConstraints": () => this.filter,
                        "constraintAttribute": "text",
                        "displayResults": (element) => this.table(element)
                    },

                    "Status": {
                        "returnAttributes": [
                            "text",
                            "id_str",
                            "scraped_at"
                        ],
                        "getPredefinedConstraints": () => this.filter,
                        "constraintAttribute": "text",
                        "displayResults": (element) => this.table(element),  
                    },

                    "Account": {
                        "returnAttributes": [
                            "screen_name",
                            "favourites_count",
                            "followers_count",
                            "following",
                            "statuses_count",
                            "scraped_at"

                        ],
                        //"getPredefinedConstraints": () => this.filter,
                        "constraintAttribute": "screen_name",
                        "displayResults": (element) => this.table(element)
                    },

                    "Url": {
                        "returnAttributes": ["display_url", "expanded_url","scraped_at"],
                        //"getPredefinedConstraints": () => this.filter,
                        "constraintAttribute": "expanded_url",
                        "displayResults": (element) => this.table(element)
                    },

                }
            }
        },

        computed: {

             /**
             * Query:
             * query spacific item from provider 
             * entity specified
             * @var <Observable>
             */
            query: {
                get(){ return (this.$route.query.hasOwnProperty('q')) ? this.$route.query.q : false }
            },

            graph_height: {
                get(){ return (this.show_table) ? 0 : 100 }
            },

            filter: {
                get(){ 
                    return this.pre_filters.concat(this.filters).map( filter_model => {
                        return `
                            date($identifier.${filter_model.attribute.trim()}) ${filter_model.operator.trim()} date('${filter_model.value.trim()}') 
                            OR 
                            $identifier.${filter_model.attribute.trim()} IS NULL`;
                    })
                }
            }

        },

        methods: {

            table(element){
            
                let list    = element.append("div").attr("class", "json-object data-list");
                let a       = list.append("a").attr('class', 'status-link').attr('target', '_blank');
                let title   = a.append('h2').text( (result) => `${result.resultIndex+1}: ${result.label}` );  
                let group   = a.append("ul");

                element.each( (data, index) => {
                    
                    let keys = Object.keys( data.attributes );

                    for (let i = keys.length - 1; i >= 0; i--) {
                        
                        let key     = keys[i];
                        let value   = data.attributes[key];

                        if(this.time_stamps.includes(key)){
                            value = new Date(value);
                        }

                        group.append('li').text(`${key.replace("_"," ")} : ${value}`);
                        if(data.label == "Status" && key==="id_str"){
                            a.attr('href', `http://twitter.com/user/status/${value}`);
                        }

                        if(data.label == "Account" && key==="screen_name"){
                            a.attr('href', `https://twitter.com/${value}`);
                        }
                        
                    }

                });
            
            },

            testQuery(){

                this.filterClause = [`n.created_at is null or n.created_at > ${new Date().getTime()}`];
                popoto.tools.reset();

            },

            stopPhysics(){
                this.viz.stabilize();
            },

            draw: function(){
                
                this.viz.renderWithCypher(this.cypher_string);
                this.show_neovis = true;
                //this.viz.renderWithCypher(this.cypher_string);
            },

            backToSearch() {
                this.show_neovis = false;
                this.viz.clearNetwork();
            },

            runQuery() {

                let html = this.$refs.cypher.innerHTML;
                let div = document.createElement("div");
                div.innerHTML = html;
                let text = div.innerText;
                let regexp = /([a-z0-9]*:`)/gm;
                let statusreg = /(\w*status\w*)/gm

                
                text = text.substring(0, text.indexOf("RETURN"));


                 //Extract status numbers
                let extractedStatuses = text.match(statusreg);
                let appendStatuses = [];
                for(let e = 0; e < extractedStatuses.length; e++){
                    if(!appendStatuses.includes(extractedStatuses[e])){
                        appendStatuses.push(extractedStatuses[e]);
                    }
                }
                //Generate Filter Strings
                let filter_string = "";
                for(let x =0; x < this.filters.length; x++) {
                    for(let y = 0; y < appendStatuses.length; y++) {
                        filter_string += `(${appendStatuses[y]}.${this.filters[x].attribute} ${this.filters[x].operator} Datetime('${this.filters[x].value.trim()}'))`
                        if(y < appendStatuses.length-1) {
                             filter_string += ' AND '
                        }
                    }

                    if(x < this.filters.length-1) {
                             filter_string += ' AND '
                     }
                    
                }

                if(text.indexOf('WHERE') === -1) {
                   text += 'WHERE ';
                }
                text += 'AND ' + filter_string;

                let replace = 0;
                for(let s = 0; s < text.length; s++){
                    if(text[s] == '[' && text[s+1] == ':'){
                        text = text.slice(0,s+1) + 'r' + replace + text.slice(s+1, text.length);
                        replace++;
                    }
                }

                let extractedObjects = text.match(regexp);
                let appendObjects = [];
                for(let e = 0; e < extractedObjects.length; e++){
                    let query_obj = extractedObjects[e].split(':')[0];
                    if(!appendObjects.includes(query_obj)){
                        appendObjects.push(query_obj);
                    }
                }
                text += ' RETURN '
                for(let x = 0; x < appendObjects.length; x++) {
                    text += appendObjects[x];
                    if(x < appendObjects.length-1) {
                        text+= ',';
                    }
                }
               
                this.cypher_string = text;
                this.draw();
            },

            killPopoto(){

                Event.$emit('kill_the_popoto');

            },


            launchPopoto(){

                popoto.result.onTotalResultCount( count => this.total = count );
                popoto.tools.TOGGLE_TAXONOMY = true;
                popoto.provider.link.Provider = {

                    "getColor": function (link) {
                        if (link.type === popoto.graph.link.LinkTypes.RELATION || link.type === popoto.graph.link.LinkTypes.SEGMENT) {
                            switch (link.label) {
                                case "HASHTAG":
                                    return "#2b6fd4";
                                case "HASHTAG_OF":
                                    return "#23a4c7";
                                case "MENTION":
                                    return "#0af";
                                case "MENTIONED_BY":
                                    return "#f50";
                                case "POSTED":
                                    return "#DE9BF9";
                                case "POSTED_BY":
                                    return "#f07";
                                case "RETWEET":
                                    return "#e0f";
                                case "RETWEETED":
                                    return "#90f";
                                case "RETWEETED_BY":
                                    return "#e9db16";
                                case "RETWEET_OF":
                                    return "#0f8";
                                case "URL":
                                    return "#ff7b00";
                                case "URL_OF":
                                    return "#f0c";
                                default :
                                    return "#A5ABB6"
                            }
                        } else {
                            return "#A5ABB6";
                        }
                    }
                };

                popoto.provider.node.DEFAULT_PROVIDER.getColor = function (node) {
                    if (node.type !== popoto.graph.node.NodeTypes.ROOT) {
                        let linknode = node;
                        if (node.type === popoto.graph.node.NodeTypes.VALUE) {
                            linknode = node.parent;
                        }
                        let color = "#A5ABB6";
                        if (linknode.parentRel !== undefined) {
                            color = popoto.provider.link.getColor({
                                label: linknode.parentRel,
                                source: linknode.parent,
                                target: linknode,
                                type: popoto.graph.link.LinkTypes.RELATION
                            });
                        }
                        return color;
                    } else {
                        return "#A5ABB6";
                    }
                };

                popoto.start("Account");


            }


        },

        created () {

            /**
             * URL used to access Neo4j REST API to execute queries.
             * Update this parameter to your running server instance.
             *
             * For more information on Neo4J REST API the documentation is available
             * here: http://neo4j.com/docs/stable/rest-api-cypher.html
             */
            popoto.rest.CYPHER_URL = process.env.VUE_APP_CYPHER_URL;

            /**
             * HTTP authentication.
             * The value of this property must be "Basic <payload>", where "payload" is a base64
             * encoded string
             *
             * "btoa" is a JavaScript function that can be used to encode the user and password
             * value in base64 but it is recommended to directly use the Base64 value.
             */
            popoto.rest.AUTHORIZATION = `Basic ${encode.encode(process.env.VUE_APP_NEO4J_PASSWORD, 'base64')}`

            /**
             * Define the Label provider you need for your application.
             * This configuration is mandatory and should contain at least all the labels you could find in your graph model.
             *
             * In this version only nodes with a label are supported.
             *
             * By default If no attributes are specified Neo4j internal ID will be used.
             * These label provider configuration can be used to customize the node display in the graph.
             * See www.popotojs.com or example for more details on available configuration options.
             */
            popoto.provider.node.Provider = this.providers;

            /**
             * The number of results returned can be changed with the following parameter.
             * Default value is 100.
             *
             * Note that in this current version no pagination mechanism is available in displayed results
             */
            popoto.query.RESULTS_PAGE_SIZE = 50;

            /**
             * You can activate debug traces with the following properties:
             * The value can be one of these values: DEBUG, INFO, WARN, ERROR, NONE.
             *
             * With INFO level all the executed cypher query can be seen in the navigator console.
             * Default is NONE
             */
            //popoto.logger.LEVEL = process.env.NODE_ENV == "development" ? popoto.logger.LogLevels.INFO : popoto.logger.LogLevels.ERROR;

            popoto.logger.LEVEL = popoto.logger.LogLevels.ERROR;

        },

        mounted(){

            this.launchPopoto();

            //this.launchPopoto();

            let config = {
                    container_id: "viz",
                    server_url: process.env.VUE_APP_BOLT_URL,
                    server_user: process.env.VUE_APP_NEO4J_USER,
                    server_password: process.env.VUE_APP_NEO4J_PASSWORD,
                    encrypted: "ENCRYPTION_ON",
                    labels: {
                        "Account": {
                            "caption": "screen_name"
                        },
                        "Hashtag": {
                            "caption": "hashtag"
                        },
                        "Status": {
                            "caption": false
                        },
                        "Url": {
                            "caption": "url"
                        }
                    },
                    relationships: {
                        "HASHTAG": {
                             "caption": true,
                        },
                        "HASHTAG_OF": {
                             "caption": true,
                        },
                        "MENTION": {
                             "caption": true,
                        },
                        "MENTIONED_BY": {
                             "caption": true,
                        },
                        "POSTED": {
                             "caption": true,
                        },
                        "POSTED_BY": {
                             "caption": true,
                        },
                        "RETWEET": {
                             "caption": true,
                        },
                        "RETWEETED": {
                             "caption": true,
                        },
                        "RETWEETED_BY": {
                             "caption": true,
                        },
                        "RETWEET_OF": {
                             "caption": true,
                        },
                        "URL": {
                             "caption": true,
                        },
                        "URL_OF": {
                             "caption": "url_of",
                        }
                        
                    },
                    initial_cypher: ""
                };

                this.viz = new neovis.default(config);
                this.viz.render();

        }



    }
</script>

